import { render, staticRenderFns } from "./ItemCreateFromGlobal.vue?vue&type=template&id=4878bd73"
import script from "./ItemCreateFromGlobal.vue?vue&type=script&lang=js"
export * from "./ItemCreateFromGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports